export default "__VITE_ASSET__CRznRBBg__"